import { Component, OnInit, Input } from '@angular/core';
import { CalculationMethod, SteppedCalMethodViewModel } from '../../model/measurement-points.model';

@Component({
  selector: 'stepped-cal-method',
  templateUrl: './stepped-cal-method.component.html',
  styleUrls: ['./stepped-cal-method.component.scss']
})
export class SteppedCalMethodComponent implements OnInit {


  @Input() steppedCalMethod: SteppedCalMethodViewModel;
  constructor() { }

  ngOnInit() {
    if(this.steppedCalMethod==undefined)
      this.steppedCalMethod = new SteppedCalMethodViewModel();
  }

  saveChanges() {
  
  }


}
